export const columns = [
  {
    title: 'Material',
    dataIndex: 'material',
    key: 'material',
    ellipsis: true,
    width: '200px',
    render: (record) => {
      {
        return record?.name;
      }
    },
    responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
  },
  {
    title: 'Material Code',
    dataIndex: 'material',
    key: 'material_code',
    ellipsis: true,
    width: '150px',
    render: (record) => {
      {
        return record?.code;
      }
    },
    responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
  },
  {
    title: 'In House Batch No',
    dataIndex: 'material',
    key: 'in_house_batch_no',
    ellipsis: true,
    width: '150px',
    render: (record) => {
      {
        return record?.in_house_batch_no;
      }
    },
    responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
  },
  {
    title: 'Required Weight',
    dataIndex: 'required_weight',
    key: 'required_weight',
    ellipsis: true,
    width: '150px',
    render: (record) => {
      {
        return record;
      }
    },
    responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
  }
];

// One row per line clearance checklist question, in the order they are asked.
// `name`    - the form field and the key the create APIs expect (the DB column).
// `readKey` - the key the GET returns. The dispensing read (lc/get-all) aliases four
//             of these columns; the sampling read (batch/get-all) returns them raw,
//             so both keys are needed to read a WH answer on either flow.
export const LC_QUESTIONS = [
  {
    name: 'no_containers_of_previous_material',
    readKey: 'no_containers_of_previous_material',
    label: 'No containers of previous material were observed in the area'
  },
  {
    name: 'checked_unavailablity_used_dispensing_sample_aids_area',
    readKey: 'sample_aids_area',
    label:
      'Checked for the unavailability of used dispensing/sampling aids in the area'
  },
  {
    name: 'checked_unavailablity_vivible_powder_observed_around_the_area',
    readKey: 'vivible_powder',
    label:
      'Checked for the unavailability of visible powder observed around the balance'
  },
  {
    name: 'dustbins_are_cleared',
    readKey: 'dustbins_are_cleared',
    label: 'Dustbins are cleared, and scraps are removed'
  },
  {
    name: 'cleaning_of_floor',
    readKey: 'cleaning_of_floor',
    label:
      'Cleaning of floor, Stainless steel panels of dispensing/sampling booth'
  },
  {
    name: 'cleaning_of_covings',
    readKey: 'cleaning_of_covings',
    label: 'Cleaning of the covings'
  },
  {
    name: 'cleaning_of_electrical',
    readKey: 'cleaning_of_electrical',
    label: 'Cleaning of the electrical fixtures of dispensing/sampling booth'
  },
  {
    name: 'previous_record_removed',
    readKey: 'previous_record_removed',
    label: 'Previous records removed from the area'
  },
  {
    name: 'cleaniness_working_area',
    readKey: 'cleaniness_working_area',
    label: 'Cleanliness of the working area'
  },
  {
    name: 'balance_calbration_carried_out',
    readKey: 'balance_calbration_carried_out',
    label: 'Balance calibration carried out'
  },
  {
    name: 'check_the_packing_condition',
    readKey: 'check_the_packing_condition',
    label:
      'Checked the packing condition of the to be dispensed/sampling materials and found satisfactory'
  },
  {
    name: 'checked_the_material',
    readKey: 'checked_the_material',
    label:
      'Checked the material name, material code, approved status etc. by scanning of QR code of to be dispensed material'
  },
  {
    name: 'checked_the_retest_date',
    readKey: 'checked_the_retest_date',
    label:
      'Checked the retest date, best before use date and expiry date of to be dispensed/sampling material through QR code scanning and found satisfactory'
  },
  {
    name: 'swab_results_of_previous_product',
    readKey: 'swab_results',
    label: 'Swab results of previous product (If any) are found satisfactory'
  },
  {
    name: 'availability_cleanness_nitrogen',
    readKey: 'availability_cleanness_nitrogen',
    label: 'Availability & cleanliness of nitrogen purging'
  },
  {
    name: 'sodium_vapour_lamps_required_proposed_product',
    readKey: 'sodium_vapour_lamps',
    label: 'Sodium vapor lamps required for proposed product'
  },
  {
    name: 'cleaniness_of_pass_box',
    readKey: 'cleaniness_of_pass_box',
    label: 'Check the cleanliness of pass box'
  },
  {
    name: 'ensure_the_cleanliness_and_validity',
    readKey: 'ensure_the_cleanliness_and_validity',
    label:
      'Ensure the cleanliness and cleanliness validity of the dispensing aids as per the status label'
  },
  {
    name: 'ensure_the_cleanliness_of_the_label',
    readKey: 'ensure_the_cleanliness_of_the_label',
    label:
      'Ensure the cleanliness of the Label counting machine and verify the usage logbook up-dation'
  },
  {
    name: 'ensure_that_if_any_gaps_observed',
    readKey: 'ensure_that_if_any_gaps_observed',
    label:
      'Ensure that if any gaps observed in dispensing /sampling booth shall be closed with suitable'
  }
];

export const getResponseText = (value) => {
  if (value == 1) return 'Yes';
  if (value == 2) return 'No';
  if (value == 3) return 'NA';
  return 'Not Filled';
};

// The radios hold numbers, the API returns the varchar column. Compare as strings and
// treat blank/absent as "no answer" so the two never look different for the wrong reason.
export const normalizeResponse = (value) =>
  value === null || value === undefined || value === '' ? null : String(value);

// Read one question's answer off a checklist row, whichever key shape it arrived in.
export const answerOf = (row, question) =>
  row?.[question.readKey] ?? row?.[question.name];

// An override is QA recording a different answer to one the WH user actually gave.
// A blank on either side is a gap in the record, not a disagreement, so it is not
// flagged - that also keeps legacy clearances written before lc_type existed, which
// have no identifiable WH row, from showing a page full of false differences.
export const isOverride = (question, whRow, qaValue) => {
  const wh = normalizeResponse(answerOf(whRow, question));
  const qa = normalizeResponse(qaValue);
  return wh !== null && qa !== null && wh !== qa;
};

// The questions QA has answered differently to the WH user, given live form values.
export const getOverrides = (whRow, values) =>
  LC_QUESTIONS.filter((question) =>
    isOverride(question, whRow, values?.[question.name])
  );
